/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { routerPush, setSessionStorage } from '@tcp/core/src/utils';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor/views/Anchor';
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { RightArrowButton } from '../styles/HorizontalCategory.style';
import { ShopAllLink, ShopAllContent } from '../styles/ShopAllTile.style';
import { SLASH_C_ROUTE, SLASH_C_PATH } from '../../../../../constants/plp.constants';
import { isShopThisStoreModeOn } from '../../../../../reduxStore/selectors/session.selectors';
import { SHOP_THIS_STORE_SCROLL } from '../../../../../constants/shopThisStore.constant';

const deviceDisplayMap = {
  desktop: 4,
  mobile: 2,
};

const constructPaths = (categoryInfo) => {
  const { seoToken, url } = categoryInfo;
  const redirectSeoToken = url?.replace('#redirect', '')?.replace('/c?cid=', '') || seoToken;
  const asPath = `${SLASH_C_ROUTE}${redirectSeoToken}`;
  let href = `${SLASH_C_PATH}cid=${redirectSeoToken}`;
  if (isShopThisStoreModeOn()) {
    setSessionStorage({ key: SHOP_THIS_STORE_SCROLL, value: window.scrollY });
    href = `${SLASH_C_PATH}cid=${url?.split('?')[0]}`;
  }
  return { asPath, href };
};

const ShopAllTile = (props) => {
  const { shopAllLabel, numberOfProducts, itemsLabel, categoryInfo, device } = props;

  if (numberOfProducts <= deviceDisplayMap[device]) return null;

  const { asPath: asPathNew, href: hrefnew } = useMemo(
    () => constructPaths(categoryInfo),
    [categoryInfo]
  );

  const handleLinkClick = (e) => {
    e.preventDefault();
    const { id } = categoryInfo;
    setLocalStorage({ key: 'prevCatId', value: id });
    const { asPath, href } = constructPaths(categoryInfo);
    routerPush(href, asPath);
  };
  return (
    <ShopAllLink onClick={(e) => handleLinkClick(e)}>
      <Anchor
        title={shopAllLabel}
        onClick={(e) => e.preventDefault()}
        asPath={asPathNew}
        to={hrefnew}
      >
        <ShopAllContent>
          <div className="shop-all-label">{`${shopAllLabel} ${numberOfProducts} ${itemsLabel}`}</div>
          <RightArrowButton />
        </ShopAllContent>
      </Anchor>
    </ShopAllLink>
  );
};
ShopAllTile.propTypes = {
  shopAllLabel: PropTypes.string,
  numberOfProducts: PropTypes.number,
  itemsLabel: PropTypes.string,
  categoryInfo: PropTypes.shape({
    url: PropTypes.string,
    seoToken: PropTypes.string,
  }),
  device: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
};
ShopAllTile.defaultProps = {
  shopAllLabel: 'Shop all',
  numberOfProducts: 0,
  itemsLabel: 'items',
  categoryInfo: {
    url: '',
    seoToken: '',
  },
};
export default ShopAllTile;
